export default "__VITE_ASSET__c513728e__"